import { createSelector } from "reselect";
import { RequestStatus } from "./sessionReducer";
import { ErrorModal, Toast } from "./uiReducer";
import { RootState } from "@/lib/redux/rootReducer";
import { DigitalToolsRoleName, DigitalToolsUser } from "@/types";

export const getToasts = (state: RootState): Toast[] => state.ui.toasts;
export const getErrorModals = (state: RootState): ErrorModal[] =>
  state.ui.errorModals;

export const getSession = (
  state: RootState,
): {
  sessionKey?: string;
  user?: DigitalToolsUser;
  loading: boolean;
  userRequestStatus: RequestStatus;
} => ({
  sessionKey: state.session.sessionKey,
  user: state.session.user,
  loading: [RequestStatus.initial, RequestStatus.request].includes(
    state.session.userRequestStatus,
  ),
  userRequestStatus: state.session.userRequestStatus,
});

export const getActiveAudio = (state: RootState): string =>
  state.ui.activeAudioHandle;

// roles
export const selectUserRole = (state: RootState) => state.session.user?.role;

const selectIsRole = (role: DigitalToolsRoleName) =>
  createSelector([selectUserRole], (userRole) => userRole === role);

export const selectIsSeller = selectIsRole(DigitalToolsRoleName.Seller);
export const selectIsApiUser = selectIsRole(DigitalToolsRoleName.Api);
